module.exports = __webpack_public_path__ + "static/media/metervibe_app_desktop_3.2edbd913.png";